import { useAppConfig } from "@/api/app-config/useAppConfig";

// NOTE: NSAI-8010 — true when IS_USER_ANALYTICS_ENABLED is "true" on the
// server, which also refuses the /token-usage/user-analytics routes while it is
// off. The pane additionally needs the token cost usage flag and an owner.
export const useUserAnalyticsEnabled = (): boolean => {
  const { data } = useAppConfig();
  return data?.features.isUserAnalyticsEnabled ?? false;
};
